import { COMMON_GCF_COMPONENT_CONFIG } from './gcfComponentCommonConfig';

export const LOV_COMPONENT_CONFIG = {
  ...COMMON_GCF_COMPONENT_CONFIG,
  productList: {
    config: {
      visuals: {
        visible: true,
        visualsSource: 'lineup',
        visualsLength: 3,
        items: [],
      },
    },
  },
};
